import getConfig from 'next/config';

interface IRuntimeConfig {
  HOST: string;
  ROBOTS_FILE: string;
  NODE_ENV: 'development' | 'production';
  DEV: boolean;
  PROD: boolean;
  CACHE_TIME_HOURS: number;
  FREE_COURSES_ID: number;
  POPULAR_COURSES_ID: number;
  LOAD_LIMIT: number;
  YA_METRIKA_ID: string;
  GOOGLE_METRIKA_ID: string;
}

interface IServerRuntimeConfig {
  HOST_INNER?: string;
  ROBOTS_FILE: string;
}

function getRuntimeConfig(): IRuntimeConfig {
  const config = getConfig();

  // app router does not support runtime configuration
  // TODO: replace this object with environment
  if (!config) {
    return {
      HOST: process.env.HOST,
      NODE_ENV: (process.env.NODE_ENV as IRuntimeConfig['NODE_ENV']) || 'development',
      DEV: process.env.NODE_ENV === 'development',
      PROD: process.env.NODE_ENV !== 'development',
      ROBOTS_FILE: process.env.ROBOTS_FILE,
      LOAD_LIMIT: Number(process.env.LOAD_LIMIT ?? '20'),
      FREE_COURSES_ID: Number(process.env.FREE_COURSES_ID ?? '31'),
      POPULAR_COURSES_ID: Number(process.env.POPULAR_COURSES_ID ?? '30'),
      YA_METRIKA_ID: process.env.YA_METRIKA_ID,
      GOOGLE_METRIKA_ID: process.env.GOOGLE_METRIKA_ID,
      CACHE_TIME_HOURS: Number(process.env.CACHE_TIME_HOURS ?? '1'),
    };
  }

  return config.publicRuntimeConfig;
}

function getServerRuntimeConfig(): IServerRuntimeConfig {
  const config = getConfig();

  // app router does not support server runtime configuration
  // TODO: replace this object with environment
  if (!config) {
    return {
      ROBOTS_FILE: process.env.ROBOTS_FILE,
      HOST_INNER: process.env.HOST_INNER,
    };
  }

  return config.serverRuntimeConfig;
}

export const runtimeConfig = getRuntimeConfig();

export const serverRuntimeConfig = getServerRuntimeConfig();
